import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MdSnackBar } from '@angular/material';
import { Product } from '../../models/Product';
import { SoftwareService } from '../../shared/software.service';
import { AuthService } from '../../shared/auth.service';

@Component({
    selector: 'productedit',
    providers: [AuthService], 
    templateUrl: './productedit.component.html',
    styleUrls: ['./productedit.component.css']
})
export class ProductEditComponent {
    releaseStatus = [
        ['Prototype', 0],
        ['Alpha', 1],
        ['Beta', 2],
        ['Internal', 3],
        ['Dealership', 4],
        ['Production', 5],
        ['Obsolete', 6]
        ];

    product: Product = new Product();
    originalProduct: Product = new Product();

    busy: boolean = false;

    constructor(private softwareService: SoftwareService, public auth: AuthService, public snackBar: MdSnackBar, private route: ActivatedRoute) {
        let productId = route.snapshot.params['id'];
        if (productId > 0) {
            this.busy = true;
            this.getProduct(productId);
        }
    }

    cancel() {
        this.product = new Product(
            this.originalProduct.Id,
            this.originalProduct.UpdateId,
            this.originalProduct.Name,
            this.originalProduct.Description,
            this.originalProduct.Status,
            this.originalProduct.ImageUrl,
            this.originalProduct.IconUrl
        );
    }

    getProduct(id: number) {
        this.softwareService.getProductById(id).subscribe(result => {
            this.originalProduct = result.json();
            this.product = new Product(
                this.originalProduct.Id,
                this.originalProduct.UpdateId,
                this.originalProduct.Name,
                this.originalProduct.Description,
                this.originalProduct.Status,
                this.originalProduct.ImageUrl,
                this.originalProduct.IconUrl
            );
            this.busy = false;
        }, err => {
            this.busy = false;
            this.product = new Product();
            this.snackBar.open('Error loading product', null, { duration: 3000 });
        });
    }

    saveProduct(product) {
        this.busy = true;
        if (this.auth.authenticated && this.auth.hasPermission('write:products')) {
            this.softwareService.saveProduct(product).subscribe(result => {
                console.log('Post product result: ', result);
                if (result.ok) {
                    this.originalProduct = result.json();
                    this.product = new Product(
                        this.originalProduct.Id,
                        this.originalProduct.UpdateId,
                        this.originalProduct.Name,
                        this.originalProduct.Description,
                        this.originalProduct.Status,
                        this.originalProduct.ImageUrl,
                        this.originalProduct.IconUrl
                    );
                    this.busy = false;
                    this.snackBar.open('Product Saved', null, {
                        duration: 3000,
                    });
                } else {
                    this.busy = false;
                    this.snackBar.open('Error saving product', null, {
                        duration: 3000,
                    });
                }
            }, err => {
                this.busy = false;
                this.snackBar.open('Error saving product', null, {
                    duration: 3000,
                });
            });
        } else {
            this.busy = false;
            this.snackBar.open('Please login', null, {
                duration: 3000,
            });
        }
    }
}



// WEBPACK FOOTER //
// ./Client/app/containers/productedit/productedit.component.ts